export default __webpack_public_path__ + "static/bg-eugeni-02-1927771095cbbee45652bbff9a512d9d.jpg";